import {
  Component,
  inject,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';

import { TravelBoardService } from '../../services/travel-board.service';
import { TravelBoardData } from '../../../shared/model/travel-board-data';
import { TableViewComponent } from '../table-view/table-view.component';
import { TableSettingsComponent } from '../table-settings/table-settings.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { FilterTripsComponent } from '../filter-trips/filter-trips.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { GridViewComponent } from '../grid-view/grid-view.component';

@Component({
  selector: 'app-board-trip-list-section',
  imports: [
    TableSettingsComponent,
    TranslocoPipe,
    ButtonModule,
    TooltipModule,
    FilterTripsComponent,
    SelectButtonModule,
    FormsModule,
    TableViewComponent,
    GridViewComponent,
  ],
  templateUrl: './board-trip-list-section.component.html',
})
export class BoardTripListSectionComponent {
  travelBoardService = inject(TravelBoardService);
  @ViewChild(TableViewComponent) tableView?: TableViewComponent;

  @Output() searchChange = new EventEmitter<string>();
  @Output() filterChange = new EventEmitter<'all' | 'draft' | 'notDraft'>();
  @Output() paginationChange = new EventEmitter<{
    page: number;
    rows: number;
  }>();

  selectedItems: TravelBoardData[] = [];
  isInTableMode: boolean = true;

  viewModeOptions = [
    { label: 'table view', icon: 'pi pi-bars', value: true },
    { label: 'grid view', icon: 'pi pi-th-large', value: false },
  ];

  constructor() {
    this.isInTableMode = JSON.parse(
      localStorage.getItem('isInTableMode') || 'true',
    );
  }

  onModeChange(): void {
    localStorage.setItem('isInTableMode', this.isInTableMode.toString());
    this.travelBoardService.resetPagination();
    this.paginationChange.emit({
      page: 0,
      rows: this.travelBoardService.paginationRows(),
    });
  }

  onSelectionChange(items: TravelBoardData[]): void {
    this.selectedItems = items;
  }

  clearSelection(): void {
    this.selectedItems = [];
    if (this.tableView) {
      this.tableView.selectedItems = [];
    }
  }

  deleteSelectedTrips(): void {
    if (this.selectedItems.length > 0) {
      const tripIds = this.selectedItems.map((item) => item.id!);
      this.travelBoardService.deleteMultipleTrips(tripIds);
      this.clearSelection();
    }
  }

  recalculateSelectedTrips(): void {
    if (this.selectedItems.length > 0) {
      const tripIds = this.selectedItems
        .filter((item) => !item.isDraft)
        .map((item) => item.id!);
      this.travelBoardService.recalculateTrips(tripIds);
      this.clearSelection();
    }
  }

  get hasUnverifiedSelection(): boolean {
    return this.selectedItems.some((item) => item.needsVerification);
  }

  markSelectedVerified(): void {
    const tripIds = this.selectedItems
      .filter((item) => item.needsVerification)
      .map((item) => item.id!);
    if (tripIds.length > 0) {
      this.travelBoardService.markVerified(tripIds);
      this.clearSelection();
    }
  }

  onSearchChange(search: string): void {
    this.searchChange.emit(search);
  }

  onFilterChange(filter: 'all' | 'draft' | 'notDraft'): void {
    this.filterChange.emit(filter);
  }

  onPaginationChange(event: { page: number; rows: number }): void {
    this.paginationChange.emit(event);
  }
}
